import { render, staticRenderFns } from "./_base-UI-CheckSlider.vue?vue&type=template&id=374b8790&scoped=true&"
import script from "./_base-UI-CheckSlider.vue?vue&type=script&lang=js&"
export * from "./_base-UI-CheckSlider.vue?vue&type=script&lang=js&"
import style0 from "./_base-UI-CheckSlider.vue?vue&type=style&index=0&id=374b8790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b8790",
  null
  
)

export default component.exports